import { ColumnTypes } from "components/collections/util/datatypes";
import { usePost } from "seed/api";
import { downloadFile } from "components/util/file_util";

const TableCallbacks = ({
	_rows,
	_columns,
	collectionOptions = {},
	cacheRef,
	isReadOnly,
	useCustomImport,
	useCustomExport,
	formValue,
	setIsFormModalShown,
	setRows,
	setSearch,
	setQuery,
	setFilters,
	setSorting,
	setSelectedCell,
	setIsEditingcell,
	onClickImport,
	onClickExport,
	onClickCell,
	onDoubleClickCell,
	updateSearch,
	updateQuery,
	updateFilters,
	updateSorting,
	_onAddRow,
	_onChangeRow,
}) => {

	const [callExportExcel] = usePost("/excel/export", {
		onCompleted: (data) => {
			downloadFile(data.url, null, data.name);
		}
	});

	const _onClickImport = (importedRows, isOverwrite) => {
		if (useCustomImport) {
			onClickImport(importedRows, isOverwrite);
		}
		else {
			importedRows = importedRows.map(row => ({ data: row }));
			setRows(isOverwrite ? importedRows : [..._rows, ...importedRows]);
		}
	}

	const _onClickExport = (extension) => {

		if (useCustomExport) {
			onClickExport(extension);
			return;
		}

		callExportExcel({
			columns: _columns,
			rows: _rows,
		});

	};

	const _updateSearch = (value) => {
		const id = Math.random();
		cacheRef.current["search"] = id;
		setTimeout(() => {
			if (cacheRef.current["search"] == id) {
				setSearch(value);
				updateSearch(value);
			}
		}, 600);
	}

	const _updateQuery = (query) => {
		setQuery(query);
		updateQuery(query);
	}

	const _updateFilter = (filters) => {
		setFilters(filters);
		updateFilters(filters);
	}

	const _updateSorting = (sorting) => {
		setSorting(sorting);
		updateSorting(sorting);
	}

	const _onClickCell = (rowData, row, column) => {
		setSelectedCell({ row, column });
		if (isReadOnly || _columns[column].type == ColumnTypes.OBJECT) return;
		onClickCell(rowData, row, column);
	}

	const _onDoubleClickCell = () => {
		if (isReadOnly) return;
		setIsEditingcell(true);
	}

	const _onBlurCell = (e) => {
		const ignore = e?.relatedTarget?.getAttribute("ignore-onclickoutside");
		if (ignore) return;
		setIsEditingcell(false);
	}

	const _onClickSubmitForm = (values) => {

		if (formValue) {
			const index = _rows.findIndex(row => row.id === formValue.id);
			_onChangeRow([
				..._columns.map((col) => ({
					name: col.name,
					value: values[col.name]
				}))
			]);
		}
		else {
			_onAddRow(Object.assign({}, values));
		}

		setIsFormModalShown(false);

	}

	return {
		_onClickImport,
		_onClickExport,
		_onClickCell,
		_onDoubleClickCell,
		_onBlurCell,
		_onClickSubmitForm,
		_updateSearch,
		_updateQuery,
		_updateFilter,
		_updateSorting,
	}

}

export default TableCallbacks;